module.exports = __webpack_public_path__ + "static/media/dot-circle-solid.257cbc35.svg";